import './ConfirmationPopUp.scss';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    compensationVouchers: string[];
    showPopUp: boolean;
    hidePopUp: () => void;
}

const ConfirmationPopUp = ({compensationVouchers, showPopUp, hidePopUp}: Props) => {
    const { t } = useTranslation();
    const [voucherCount, setVoucherCount] = useState<number>(0);

    useEffect(() => {
        setVoucherCount(0);
    }, [compensationVouchers]);

    const handleOnClickShowNextCode = () => {
        setVoucherCount(voucherCount + 1);
    };

    return (
        <Dialog
            className="app-dialog c-confirmation-popup"
            disableEscapeKeyDown
            onClose={hidePopUp}
            open={showPopUp}
            maxWidth="lg"
        >
            <DialogTitle>
                <div className="c-header">
                    <IconButton
                        aria-label="close"
                        className="icon-btn"
                        onClick={hidePopUp}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className="dialog-content">
                <div className="c-popup" id="confirmation-component">
                    <div>
                        {compensationVouchers && compensationVouchers.length ? (
                            <>
                                <p className="h-title">{t('labels.compensationHeader')}</p>
                                {compensationVouchers.map((voucher, i) => (
                                    <div key={i} className="c-web">
                                        <p className="label">{i + 1} of {compensationVouchers.length} {t('labels.requested')}</p>
                                        <p className="label-code">{voucher}</p>
                                    </div>
                                ))}
                                <div className="c-ipad">
                                    {compensationVouchers.length > 1
                                        ? <p className="label">{voucherCount + 1} of {compensationVouchers.length} requested</p>
                                        : <p className="label">1 requested</p>
                                    }
                                    <p className="label-code">{compensationVouchers.length && compensationVouchers[voucherCount]}</p>

                                    {compensationVouchers.length ? (voucherCount + 1) < compensationVouchers.length && (
                                        <p className="c-next-code" onClick={handleOnClickShowNextCode}>
                                            <span className="label-next">{t('labels.next')}</span>
                                            <span className="label-next-btn"><ArrowForwardIosIcon fontSize={'large'} /></span>
                                        </p>
                                    ) : null}
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmationPopUp;

